export default "__VITE_ASSET__CSNBPW8X__"